// extracted by mini-css-extract-plugin
export default {"row":"Characters_row__OvWhh"};